export default __webpack_public_path__ + "static/media/start-aec_DE.d40f68ed.png";